import { SkeletorTableState } from '@contrast-security-inc/design-system-tables'
import { noop } from '@tanstack/react-table'
import React, { Dispatch, PropsWithChildren, SetStateAction } from 'react'

const initialSort: SkeletorTableState['sorting'] = [
  {
    id: 'lastObservedTime',
    desc: true
  }
]
export interface ContextValue {
  sortingOrder: SkeletorTableState['sorting']
  searchText: string | undefined
  filterTextInputHasBeenInteractedWith: boolean
  setSortingOrder: Dispatch<SetStateAction<SkeletorTableState['sorting']>>
  setSearchText: Dispatch<SetStateAction<string | undefined>>
  hasData: boolean
  setHasData: Dispatch<SetStateAction<boolean>>
}

export const LibraryUsageGridContext = React.createContext<ContextValue>({
  sortingOrder: initialSort,
  setSortingOrder: noop,
  searchText: undefined,
  filterTextInputHasBeenInteractedWith: false,
  setSearchText: noop,
  hasData: false,
  setHasData: () => false
})

export const LibraryUsageGridProvider = ({ children }: PropsWithChildren) => {
  const [hasData, setHasData] = React.useState<boolean>(false)
  const [searchText, setSearchText] = React.useState<string | undefined>(
    undefined
  )
  const [sortingOrder, setSortingOrder] =
    React.useState<SkeletorTableState['sorting']>(initialSort)

  const values = React.useMemo(
    () => ({
      hasData,
      setHasData,
      sortingOrder,
      setSortingOrder,
      searchText,
      filterTextInputHasBeenInteractedWith: searchText !== undefined,
      setSearchText
    }),
    [hasData, setHasData, sortingOrder, setSortingOrder, searchText]
  )

  return (
    <LibraryUsageGridContext.Provider value={values}>
      {children}
    </LibraryUsageGridContext.Provider>
  )
}

export const useLibraryUsageGridContext = () =>
  React.useContext(LibraryUsageGridContext)
